import { Box, Paper, Stack, Typography } from '@mui/material';

import suomenVahvimmatStanding from 'assets/svg/suomen-vahvimmat/fi-standing.svg';
import ArrowLink from 'components/ArrowLink';
import { useAutoJerryReviews } from 'components/AutoJerryReviewsBadge/useAutoJerryReviews';
import { STAR_ICON_SX, STAR_ICONS, STAR_POSITIONS, formatRating, getStarTypes } from 'components/AutoJerryReviewsBadge/utils';
import { autojerryConfig } from 'config/autojerry';
import { suomenVahvimmatConfig } from 'config/suomenVahvimmat';
import { glassPanelSx } from 'theme';

const DIVIDER_SX = {
  width: { xs: '100%', lg: '1px' },
  height: { xs: '1px', lg: 'auto' },
  alignSelf: 'stretch',
  bgcolor: 'rgba(238,240,242,0.12)',
} as const;

// 5 stars * STAR_ICON_SX.fontSize (22px) + 4 gaps * 2px spacing.
const STAR_ROW_WIDTH = 118;

const TrustStrip: React.FC = () => {
  const { rating, reviewCount, updatedAt } = useAutoJerryReviews();
  const { certifiedYear, profileUrl: suomenVahvimmatProfileUrl } = suomenVahvimmatConfig;

  return (
    <Paper
      elevation={0}
      sx={{
        ...glassPanelSx,
        borderRadius: '20px',
        color: 'typography.light',
        px: { xs: 2.5, sm: 4 },
        py: { xs: 2.5, sm: 3.5 },
      }}
    >
      <Stack direction={{ xs: 'column', lg: 'row' }} spacing={{ xs: 2.5, lg: 4 }} divider={<Box sx={DIVIDER_SX} />}>
        <Stack direction='row' spacing={2.5} sx={{ alignItems: 'center', flex: 1 }}>
          <Box sx={{ width: STAR_ROW_WIDTH, display: 'flex', justifyContent: 'center', flexShrink: 0 }}>
            <Box
              component='img'
              src={suomenVahvimmatStanding}
              alt='Suomen Vahvimmat -sertifikaatti'
              sx={{ height: { xs: 72, sm: 88 }, width: 'auto' }}
            />
          </Box>
          <Stack spacing={0.5} sx={{ minWidth: 0 }}>
            <Typography variant='p3b' component='p' sx={{ m: 0 }}>
              Sertifioitu luotettava yritys
            </Typography>
            <Typography variant='p3' component='p' sx={{ m: 0, opacity: 0.6 }}>
              Suomen Vahvimmat {certifiedYear}
            </Typography>
            <ArrowLink href={suomenVahvimmatProfileUrl} color='secondary.main' sx={{ mt: 0.25 }}>
              Katso profiili
            </ArrowLink>
          </Stack>
        </Stack>
        <Stack direction='row' spacing={2} sx={{ alignItems: 'center', flex: 1 }}>
          <Stack direction='row' spacing={0.25} aria-hidden='true'>
            {getStarTypes(rating).map((starType, index) => {
              const StarComponent = STAR_ICONS[starType];

              return <StarComponent key={STAR_POSITIONS[index]} sx={STAR_ICON_SX} />;
            })}
          </Stack>
          <Stack spacing={0.5} sx={{ minWidth: 0 }}>
            <Typography variant='p3b' component='p' sx={{ m: 0 }}>
              Asiakasarvostelut AutoJerryssä
            </Typography>
            <Typography variant='p3' component='p' sx={{ m: 0, opacity: 0.6 }}>
              {formatRating(rating)} / 5 ({reviewCount} arvostelua{updatedAt !== null && `, päivitetty ${updatedAt}`})
            </Typography>
            <ArrowLink href={autojerryConfig.profileUrl} color='secondary.main' sx={{ mt: 0.25 }}>
              Lue arvosteluja
            </ArrowLink>
          </Stack>
        </Stack>
      </Stack>
    </Paper>
  );
};

export default TrustStrip;
